import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import {
  formatFivetranSyncDetail,
  formatRescheduledForDisplay,
  isRescheduledSyncState,
} from '@/utils/fivetranSyncStatus';

export interface FivetranRescheduledSyncNoticeProps {
  sync_state?: string;
  rescheduled_for?: string | null;
  sync_tasks?: Array<{ message?: string; details?: string }>;
  sync_warnings?: Array<{ message?: string; details?: string }>;
  status_reason?: unknown;
}

export function FivetranRescheduledSyncNotice({
  sync_state,
  rescheduled_for,
  sync_tasks,
  sync_warnings,
  status_reason,
}: FivetranRescheduledSyncNoticeProps) {
  if (!isRescheduledSyncState(sync_state)) return null;

  const detail = formatFivetranSyncDetail({
    syncState: sync_state,
    rescheduledFor: rescheduled_for,
    tasks: sync_tasks,
    warnings: sync_warnings,
    statusReason: status_reason,
  });

  const nextFormatted = rescheduled_for ? formatRescheduledForDisplay(rescheduled_for) : null;
  const showSeparateNext =
    !!nextFormatted && !(detail?.includes('Next sync') ?? false);

  return (
    <Alert variant="default" className="border-border bg-muted/40">
      <AlertTitle className="text-sm">Sync rescheduled</AlertTitle>
      <AlertDescription className="text-sm text-muted-foreground space-y-1">
        {detail ? <p>{detail}</p> : (
          <p>Fivetran has queued the remainder of this sync. Data may be partially available until it completes.</p>
        )}
        {showSeparateNext ? (
          <p className="text-xs">Next sync: {nextFormatted}</p>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
